var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useApiMutation } from '../../../../../infra/api';
import { endpoints } from '../../../network/endpoints';
import { showNotification } from '../../../../../../app/common/helpers/notifications';
export var useVerificationHandlers = function (oldValues, newValues, showVerificationPopup) {
    var _a = useApiMutation({
        endpoint: endpoints.profileUpdateEmail,
    }), updateEmailMutation = _a.mutateAsync, resetUpdateEmail = _a.reset;
    var _b = useApiMutation({
        endpoint: endpoints.profileUpdatePhone,
    }), updatePhoneMutation = _b.mutateAsync, resetUpdatePhone = _b.reset;
    var _c = useApiMutation({
        endpoint: endpoints.profileVerifyEmail,
    }), verifyEmailMutation = _c.mutateAsync, resetVerifyEmail = _c.reset;
    var _d = useApiMutation({
        endpoint: endpoints.profileVerifyPhone,
    }), verifyPhoneMutation = _d.mutateAsync, resetVerifyPhone = _d.reset;
    var resetAll = function () {
        resetUpdateEmail();
        resetUpdatePhone();
        resetVerifyEmail();
        resetVerifyPhone();
    };
    var saveNewPhone = function () { return updatePhoneMutation({ phone: newValues.phone || null }); };
    var saveNewEmail = function () { return updateEmailMutation({ email: newValues.email || null }); };
    var verifyNewPhone = function (code) {
        return verifyPhoneMutation({ phone: newValues.phone, phoneVerificationToken: code, optIn2FA: newValues.optIn2FA });
    };
    var verifyNewEmail = function (code) {
        return verifyEmailMutation({ email: newValues.email, emailVerificationToken: code, optIn2FA: newValues.optIn2FA });
    };
    var requestNewCodeForVerifyingNewPhone = function () { return updatePhoneMutation({ phone: newValues.phone }); };
    var requestNewCodeForVerifyingNewEmail = function () { return updateEmailMutation({ email: newValues.email }); };
    var isEmailChanged = oldValues.email !== newValues.email;
    var isPhoneChanged = oldValues.phone !== newValues.phone;
    var isTwoFaEnabled = !oldValues.optIn2FA && newValues.optIn2FA;
    var requestNewEmailCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isEmailChanged || isTwoFaEnabled)) return [3 /*break*/, 2];
                    return [4 /*yield*/, requestNewCodeForVerifyingNewEmail()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    resetAll();
                    return [2 /*return*/];
            }
        });
    }); };
    var requestNewPhoneCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isPhoneChanged || isTwoFaEnabled)) return [3 /*break*/, 2];
                    return [4 /*yield*/, requestNewCodeForVerifyingNewPhone()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    resetAll();
                    return [2 /*return*/];
            }
        });
    }); };
    var verifyEmailCode = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isEmailChanged || isTwoFaEnabled)) return [3 /*break*/, 2];
                    return [4 /*yield*/, verifyNewEmail(code)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, true];
            }
        });
    }); };
    var verifyPhoneCode = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(isPhoneChanged || isTwoFaEnabled)) return [3 /*break*/, 2];
                    return [4 /*yield*/, verifyNewPhone(code)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, true];
            }
        });
    }); };
    var updateAndConfirmUserEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var emailVerified;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isEmailChanged && !isTwoFaEnabled) {
                        return [2 /*return*/, true];
                    }
                    if (!(isEmailChanged || (isTwoFaEnabled && newValues.email))) return [3 /*break*/, 2];
                    return [4 /*yield*/, saveNewEmail()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!newValues.email) {
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, showVerificationPopup({
                            fieldName: 'email',
                            fieldValue: newValues.email,
                        })];
                case 3:
                    emailVerified = _a.sent();
                    if (!emailVerified) {
                        showNotification({
                            title: 'ERROR',
                            message: 'Email authentication failed',
                        });
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var updateAndConfirmUserPhone = function () { return __awaiter(void 0, void 0, void 0, function () {
        var phoneVerified;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isPhoneChanged && !isTwoFaEnabled) {
                        return [2 /*return*/, true];
                    }
                    if (!(isPhoneChanged || (isTwoFaEnabled && newValues.phone))) return [3 /*break*/, 2];
                    return [4 /*yield*/, saveNewPhone()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!newValues.phone) {
                        return [2 /*return*/, true];
                    }
                    return [4 /*yield*/, showVerificationPopup({
                            fieldName: 'phone',
                            fieldValue: newValues.phone,
                        })];
                case 3:
                    phoneVerified = _a.sent();
                    if (!phoneVerified) {
                        showNotification({
                            title: 'ERROR',
                            message: 'Phone authentication failed',
                        });
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var saveUserSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isPhoneVerified, isEmailVerified;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isEmailChanged && !isPhoneChanged && !isTwoFaEnabled) {
                        return [2 /*return*/, true];
                    }
                    if (!(!newValues.email && isPhoneChanged)) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateAndConfirmUserPhone()];
                case 1:
                    isPhoneVerified = _a.sent();
                    if (!isPhoneVerified) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, updateAndConfirmUserEmail()];
                case 2: return [4 /*yield*/, updateAndConfirmUserEmail()];
                case 3:
                    isEmailVerified = _a.sent();
                    if (!isEmailVerified) {
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, updateAndConfirmUserPhone()];
            }
        });
    }); };
    var verifySecondFactor = function (secondFactorType, code) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (secondFactorType === 'email') {
                return [2 /*return*/, verifyEmailCode(code)];
            }
            if (secondFactorType === 'phone') {
                return [2 /*return*/, verifyPhoneCode(code)];
            }
            return [2 /*return*/, false];
        });
    }); };
    var requestNewCode = function (secondFactorType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(secondFactorType === 'email')) return [3 /*break*/, 2];
                    return [4 /*yield*/, requestNewEmailCode()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(secondFactorType === 'phone')) return [3 /*break*/, 4];
                    return [4 /*yield*/, requestNewPhoneCode()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        saveUserSettings: saveUserSettings,
        verifySecondFactor: verifySecondFactor,
        requestNewCode: requestNewCode,
        resetAll: resetAll,
    };
};
